module.exports = __webpack_public_path__ + "static/media/man_zhusha.bf66bc54.png";